'use client';

import type { CardRenderContext } from '../../tool-config-types';
import { InlineExecutionToolCard } from '../shared/inline-execution-tool-card';
import { getHITLArtifactHeaderActions } from '../shared/hitl-artifact-header-actions';
import { parseQuery, parseResult } from './data-query-parse.utils';
import { DataQueryResultView } from './data-query-result-view';

export function renderDataQueryCard(ctx: CardRenderContext) {
  const isRunning =
    ctx.toolCallData.status === 'started' ||
    ctx.toolCallData.status === 'in-progress';
  const query = parseQuery(ctx.toolCallData.input);
  const result = isRunning ? null : parseResult(ctx.toolCallData.output);

  if (
    !isRunning &&
    !query &&
    !result &&
    !ctx.toolCallData.error &&
    ctx.toolCallData.status === 'completed'
  ) {
    return null;
  }

  const title = isRunning ? ctx.labelPresent : ctx.labelPast;

  return (
    <InlineExecutionToolCard
      title={title}
      icon={ctx.toolIcon}
      status={ctx.toolCallData.status}
      error={ctx.toolCallData.error}
      headerActions={getHITLArtifactHeaderActions(ctx)}
      defaultExpanded={false}
      autoCollapseWhenComplete={ctx.autoCollapseWhenComplete}
      forceExpanded={ctx.forceExpanded}
    >
      {result ? (
        <DataQueryResultView
          result={result}
          query={query}
          onOpenObject={ctx.onOpenObject}
        />
      ) : null}
    </InlineExecutionToolCard>
  );
}
